import { useCallback } from 'react'

import { FileUploadModal } from 'ui/components/FileUpload'
import { useGlobalModal } from 'ui/components/Modal/useGlobalModal'

type UseEditableImageFileStateProps = {
    onChange: (url?: string, filename?: string) => void
}

export function useEditableImageFileState({ onChange }: UseEditableImageFileStateProps) {
    const { show } = useGlobalModal(FileUploadModal)

    const onUploadClick = useCallback(() => {
        // Open after dropdown closes.
        setTimeout(() => {
            show({
                maxFiles: 1,
                accept: 'image/*',
                onUploadSuccess: (files) => {
                    const file = files[0]
                    if (!file) return

                    onChange(file.url, file.name)
                },
            })
        }, 200)
    }, [show, onChange])

    const onRemoveImage = useCallback(() => {
        onChange(undefined, undefined)
    }, [onChange])

    const onInteractOutside = useCallback((e: Event) => {
        const el = e.target as HTMLElement | null
        if (!el) return

        if (el.closest('.ag-custom-component-popup')) {
            e.preventDefault()
        }
    }, [])

    return {
        onRemoveImage,
        onInteractOutside,
        onUploadClick,
    }
}
